import SystemReloadModalComponent from './system-reload-modal.component'

const SystemReloadModalModule = angular.module('cdbl.system-reload-modal', [

])
  .component('cdblSystemReloadModal', SystemReloadModalComponent)
  .name

export default SystemReloadModalModule
